import { language } from 'curvy';

export const english: language.TranslationDefinition = {
	locale: 'en-us',
	translations: {
		"OK": "OK",
		"COPY": "Copy",
		"EMAIL": "Email",
		"PASS": "Password",
		"USER": "User",
		"NAME": "Name",
		"SURNAME": "Surname",
		"CREATED_BY": "Created by",
		"CREATED_BY_ME": "Me",
		"CREATED_BY_OTHERS": "Others",
		"MY_OBJECTS": "My objects",
		"SEARCH": "Search",
		"CONTACT": "Contact",
		"PHONE": "Phone",
		"DETAILS": "Details",
		"STARTDATE": "Start Date",
		"ENDDATE": "End Date",
		"CREATED_DATE": "Created date",
		"START_CREATED_DATE": "Created date - FROM",
		"END_CREATED_DATE": "Created date - TO",
		"START_PLANNED_DATE": "Planned date - FROM",
		"END_PLANNED_DATE": "Planned date - TO",
		"OIB": "PIN",
		"EDIT": "Edit",
		"ADD": "Add",
		"LOCATION": "Location",
		"CHANGE_LOCATION": "Change location",
		"CURRENT_LOCATION": "Current location" ,
		"NEW_LOCATION": "New location",
		"COMMENTS": "Comments",
		"COMMENT": "Comment",
		"STATUS": "Status",
		"GREETING_TEXT": "Welcome",
		"ERROR": "Error",
		"DELETE": "Delete",
		"SUPPLIER": "Supplier",
		"ABORT": "Abort",
		"CLEAR": "Clear",
		"CREATED_BY_SECTOR":"Created by sector",


		"SELECT_ALL": "Select all",
		"DESELECT_ALL": "Deselect all",

		"ERROR.INVALID_DATE_TEXT": "End date is before start date.",
		"ERROR.GENERIC_TEXT": "Something went wrong.",
		"ERROR.USER_EXISTS_TEXT": "There is active user with the same email address.",
		"ERROR.USER_GENERIC_TEXT": "Failed to add user.",
		"ERROR.FILE_UNAVAILABLE": "File can't be downloaded",
		"ERROR.VALIDATION": 'Validation errors found',
		"ERROR.TITLE_REQUIRED": 'Title is required',
		"ERROR.DESCRIPTION_REQUIRED": 'Description is required',
		"ERROR.LOCATION_NOT_FOUND": 'Location not found',
		"ERROR.WORK_HIERARCHY_NOT_FOUND": 'Work hierarchy not found',
		"ERROR.WRONG_FREQUENCY": "Wrong frequency",
		"ERROR.FREQUENCY_REQUIRED": 'Frequency field is required',
		"ERROR.FIRST_SERVICE_DATE_FROM_REQUIRED": 'First service date from field is required',
		"ERROR.FIRST_SERVICE_DATE_TO_REQUIRED": "First service date to field is required",
		"ERROR.END_DATE_REQUIRED": "End date field is required",
		'ERROR.WRONG_PLANNED_START_DATE_FORMAT': 'Wrong planned start date format',
		'ERROR.WRONG_PLANNED_END_DATE_FORMAT': 'Wrong planned end date format',
		'ERROR.WRONG_CUT_DATE_FORMAT': 'Wrong cut date format',
		'ERROR.PLANNED_START_DATE_NEEDS_TO_BE_BEFORE_PLANNED_END_DATE': 'Planned start date needs to be before planned end date',
		'ERROR.CUT_DATE_NEEDS_TO_BE_AFTER_PLANNED_END_DATE': 'Cut date needs to be after planned end date',
		'ERROR.WRONG_MOBILE': 'Wrong mobile',
		'ERROR.SUPPLIER_NOT_FOUND': 'Supplier not found',
		'ERROR.COST_ESTIMATE_NEEDS_TO_BE_FLOAT': 'Cost estimate needs to be float',

		'ERROR.DELETING_COLUMNS': 'Column deletion prohibited',
		'ERROR.ADDING_COLUMNS': 'Adding columns is prohibited',
		'ERROR.HIDDING_COLUMNS': 'Hiding columns is prohibited',
		'ERROR.REQUIRED_FIELDS': 'Columns marked with * are required.',
		'ERROR.PLANNED_DATE': 'Date fields must be in the format',
		'ERROR.DROP_DOWN_VALUES': 'Certain columns have a dropdown value (Working hierarchy 1,2 and 3',
		'ERROR.WORK_HIERARCHY_ORDER': 'Work hierarchies must be selected in the following order: Work hierarchy 1 -> Work hierarchy 2 -> Work hierarchy 3',


		"DOWNLOAD_TABLE": "Download table",
		"DOWNLOAD": "Download",
		"DOCUMENT.UPLOADED_TEXT": "File uploaded",
		"DOCUMENT.UPLOADED_FAIL_TEXT": "File upload failed.",
		"DOCUMENT.UNSAFE_FAIL_TEXT":"Uploaded file is not safe, therefore upload process has been aborted.",
		"DOCUMENT.UPLOADED_TOO_BIG_TEXT": (names) => `Maximum size must not exceed 10MB. Document(s) ${names} are too big.`,
		"ADMIN-BUTTONS": "Admin's actions",

		"MANUAL": "Manual",
		"MANAGE_ACCOUNT": "Manage account",

		"CATEGORY": "Category",
		"DESCRIPTION": "Description",
		"SUBCATEGORY": "Subcategory",
		"GROUP": "Group",
		"SECTOR": "Sector",
		// "CREATED": "Assigned",
		// "ASSIGNED": "Assigned",
		"ASSIGNED": "Assigned",
		"BY_ME": "By me",
		"BY_OTHERS": "By others",

		"NAVROUTE.LOGOUT": "Log out",
		"LOGOUT": "Log out",

		"NAVROUTE.MAIN": "Master data",
		"NAVROUTE.COMPANIES": "Companies",
		"NAVROUTE.DASHBOARD": "Dashboard",
		"NAVROUTE.USERS": "Users",
		"NAVROUTE.LOCATIONS": "Locations",
		"NAVROUTE.LOCATION_GROUPS": "Location groups",
		"NAVROUTE.METERS": "Meters",
		"NAVROUTE.SUPPLIERS": "Suppliers",
		"NAVROUTE.ORDERS": "Orders",
		"NAVROUTE.ORDER": (order_id) => `Order #${order_id}`,
		"NAVROUTE.TICKETS": "Tickets",
		"NAVROUTE.TICKET": (ticket_id) => `Ticket #${ticket_id}`,
		"NAVROUTE.WORKGROUPS": "Work groups",
		"NAVROUTE.SECTORS": "Sectors",
		"NAVROUTE.WORKHIER": "Work hierarchy",
		"NAVROUTE.PRICELIST": "Pricelist",
		"NAVROUTE.REPORTS": "Reports",
		"NAVROUTE.ARRIVALS": "Arrivals",
		"NAVROUTE.ARRIVAL": (arrival_id) => `Arrival #${arrival_id}`,
		"NAVROUTE.ANALYTICS": "Analytics",
		"NAVROUTE.SETTINGS": "Settings",
		"NAVROUTE.EDIT_QUESTIONNAIRES": "Edit questionnaire",
		"NAVROUTE.CALENDAR": "Calendar",
		"NAVROUTE.SHELF_FILLER": "Shelf stocking",
		"NAVROUTE.SCHEDULED_ORDERS": "Scheduled orders",
		"NAVROUTE.CHECKLISTS": "Check lists",
		"NAVROUTE.ADMIN": "Admin panel",
		"NAVROUTE.REQUESTS": "Request log",
		"NAVROUTE.LABEL_FLAGS": 'Labels',
		"NAVROUTE.COMPANY_SETTINGS": "Company settings",
		"NAVROUTE.JOB_MANAGEMENT": "Job management",
		"NAVROUTE.TEMPS_REQUESTS": "Temp staff requests",
		"NAVROUTE.EXTERNAL_WORKERS": "External workers",
		"NAVROUTE.WORKING_HOURS": "Working hours",
		"NAVROUTE.APPLICATIONS": "Job applications",
		"NAVROUTE.JOBS_CALENDAR": "Job calendar",

		"DELETED": "Deleted",

		"TICKET": "Ticket",
		"ORDER": "Order",
		"ARRIVAL": "Arrival",
		"SCHEDULED_ORDER": "Scheduled order",

		"STATUS.CREATED": "Created",
		"STATUS.HAS_ARRIVAL": "Arrival created",
		"STATUS.INACTIVE": "Inactive",
		"STATUS.APPROVED": "Approved",
		"STATUS.ON_HOLD": "On hold",
		"STATUS.IN_EXECUTION": "In execution",
		"STATUS.EXECUTED": "Executed",
		"STATUS.INVOICED": "Invoiced",
		"STATUS.DELETED": "Deleted",
		"STATUS.REJECTED": "Rejected",
		"STATUS.ON_COMPANY_REVIEW": "Pre-Invoicing",
		"STATUS.ON_SUPPLIER_REVIEW": "Pre-Invoicing",
		"STATUS.UNDONE": "Not done",
		"STATUS.WORKS_FINISHED": "Works finished",

		"STATUS.ON_COMPANY_REVIEW.1": "Pre-Invoicing",
		"STATUS.ON_SUPPLIER_REVIEW.1": "Pre-Invoicing (Supplier)",
		"STATUS.PING_PONG_CHANGED": "Ping-pong item changed",

		"ARRIVAL_DATE": "Arrival announced",
		"ARRIVAL_WORKERS": "Workers",

		"PRIORITY": "Priority",
		"PRIORITY.LOW": "Low priority",
		"PRIORITY.MEDIUM": "Medium priority",
		"PRIORITY.HIGH": "High priority",

		"ORDER_PRIORITY.P1_CRITICAL": "Critical",
		"ORDER_PRIORITY.P1_CRITICAL.DESC": "Safety risk, business interruption, critical infrastructure unavailability",
		"ORDER_PRIORITY.P2_HIGH": "High",
		"ORDER_PRIORITY.P2_HIGH.DESC": "Significant business impact, but partial operation is possible",
		"ORDER_PRIORITY.P3_MEDIUM": "Medium",
		"ORDER_PRIORITY.P3_MEDIUM.DESC": "Limited business impact or small number of affected clients",
		"ORDER_PRIORITY.P4_LOW": "Low",
		"ORDER_PRIORITY.P4_LOW.DESC": "Minor failure without significant business impact",

		"RELATED.TICKETS": "Related tickets",
		"RELATED.ORDERS": "Related orders",
		"RELATED.ARRIVALS": "Related arrivals",

		"FINANCIAL.TITLE": "Financial details",
		"FINANCIAL_2.TITLE": "Financial elaboration",
		"FINANCIAL.INVOICE": "Invoicing",
		"FINANCIAL.INVOICE.TITLE": "Enter invoice number",
		"FINANCIAL.INVOICE.LABEL": "Invoice no.",
		"FINANCIAL.PDF_BY_LOCATION": "Approved by location",
		"FINANCIAL.PDF_ALL": "All elements",
		"FINANCIAL.CONFIRM_TITLE": (count)=>`${count} undisputed items`,
		"FINANCIAL.CONFIRM_TEXT": "Undisputed items will be confirmed and you won't be able to change them later. Are you sure you want to confirm all itmes?",
		"FINANCIAL.TAX_DISCLAIMER" : "Tax not included",
		"FINANCIAL.CHANGED_ITEM": "Changed item",
		"FINANCIAL.ITEM_DETAILS": "Item details",
		"FINANCIAL.NEW_ITEM": "New item",


		"CLICK_TO_EXPAND": "Click to expand",
		"CHECKLISTS.ADD_NEW_Q": "Add new question",

		"PDF.ORDER": "Invoice proposal",
		"PDF.ARRIVALS": "Work order",
		"PDF.ORDER.NO_PRICES": "Invoice proposal without prices",

		"KAM.ATTR": "Attributes",

		"INVENTORY.RECENT_ORDERS": "Recent orders",
		"INVENTORY.RECENT_ORDERS.TEXT": "The following orders have recently been related to this inventory:",
		"INVENTORY.PICK": "Add inventory elements",
		"EVENT.PICK": "Choose event type",
		"USER.TAKE_OVER_LOCATIONS": "User replacement",
		"USER.RESPONSIBLE": "Responsible user",

        "SUPPLIER.IMPORT": "Import scheduled orders",
		"SUPPLIER.IMPORT_SERVICE": 'Offer to import service',
		"SUPPLIER.IMPORT_DOWNLOAD_SERVICE": "Rules for editing service",
        "SUPPLIER.DOWNLOAD": "Download scheduled order",
        "SUPPLIER.DIALOG_TITLE": (supp) =>`Import pricelist dialog for ${supp}`,
        "SUPPLIER.ERRORS.DEFAULT": "Error in xlsx table processing.\n Error on table rows: ",
        "SUPPLIER.ERRORS": "Error: imported table hasn't been accepted.",
        "SUPPLIER.SUCCESS": "Pricelist has been uploaded",

		"REQUIRED_FILEDS": "Mandatory fields",
		"APPROVE" : "Approve",
		"REJECT": "Reject",

		'LOCGROUPS.NFC_ON': 'NFC scan for all locations',
        'LOCGROUPS.NFC_OFF': 'Remove NFC scan for all locations',
		'LOCGROUPS.NFC_ON_TITLE': 'Scanning arrivals with NFC on locations in this group has been ENABLED.',
		'LOCGROUPS.NFC_OFF_TITLE': 'Scanning arrivals with NFC on locations in this group has been DISABLED.',
		'LOCGROUP.LOCATION_NCF': 'NFC on location',
		'LOCGROUP.GROUP_NFC': 'NFC on group',

		'SHOW_MORE': (num)=> num > 3 ? `Show all ${num}` : 'Show all',
		'COMPANY': 'Company',

		"FROM": "From",
		"TO": "To",

	}
};

export const croatian: language.TranslationDefinition = {
	locale: 'hr-hr',
	translations: {
		"OK": "OK",
		"COPY": "Kopiraj",
		"EMAIL": "Email",
		"PASS": "Lozinka",
		"USER": "Korisnik",
		"NAME": "Ime",
		"SURNAME": "Prezime",
		"CREATED_BY": "Kreirao",
		"CREATED_BY_ME": "Ja",
		"CREATED_BY_OTHERS": "Drugi",
		"MY_OBJECTS": "Moji objekti",
		"SEARCH": "Traži",
		"CONTACT": "Kontakt",
		"PHONE": "Telefon",
		"DETAILS": "Detalji",
		"STARTDATE": "Početno vrijeme",
		"ENDDATE": "Vrijeme završetka",
		"CREATED_DATE": "Datum kreiranja",
		"START_CREATED_DATE": "Datum kreiranja - OD",
		"END_CREATED_DATE": "Datum kreiranja - DO",
		"START_PLANNED_DATE": "Datum planiranja - OD",
		"END_PLANNED_DATE": "Datum planiranja - DO",
		"OIB": "OIB",
		"EDIT": "Uredi",
		"ADD": "Dodaj",
		"CREATE": "Dodaj",
		"DELETE": "Obriši",
		"SUPPLIER": "Dobavljač",
		"ABORT": "Otkaži",
		"CLEAR": "Ukloni",
		"CREATED_BY_SECTOR":"Kreator po sektoru",
		"SELECT_ALL": "Označi sve",
		"DESELECT_ALL": "Odznači sve",

		"DOWNLOAD_TABLE": "Preuzmi tablicu",
		"DOWNLOAD": "Preuzmi",
		"DOCUMENT.UPLOADED_TEXT": "Datoteka uspješno uvezena.",
		"DOCUMENT.UPLOADED_FAIL_TEXT": "Datoteka se nije uspjela prebaciti.",
		"DOCUMENT.UNSAFE_FAIL_TEXT":"Datoteka nije sigurna. Prebacivanje je otkazano.",
		"DOCUMENT.UPLOADED_TOO_BIG_TEXT": (names)=> `Maksimalna dozvoljena veličina je 10MB. Datoteka ${names} je prevelika.`,
		"ADMIN-BUTTONS": "Administratorske radnje",


		"CATEGORY": "Kategorija",
		"DESCRIPTION": "Opis",
		"SUBCATEGORY": "Potkategorija",
		"GROUP": "Grupa",
		"SECTOR": "Sektor",
		"ASSIGNED": "Dodijeljen",
		"BY_ME": "Meni",
		"BY_OTHERS": "Drugima",
		"LOCATION": "Lokacija",
		"CHANGE_LOCATION": "Promijeni lokaciju",
		"CURRENT_LOCATION": "Trenutna lokacija" ,
		"NEW_LOCATION": "Nova lokacija",
		"COMMENTS": "Komentari",
		"COMMENT": "Komentar",
		"STATUS": "Status",
		"GREETING_TEXT": "Pozdrav",

		"ERROR": "Greška",
		"ERROR.INVALID_DATE_TEXT": "Datum završetka ne smije biti prije datuma početka dolaska.",
		"ERROR.GENERIC_TEXT": "Nešto je pošlo po zlu.",
		"ERROR.USER_EXISTS_TEXT": "E-mail adresa je već iskorištena.",
		"ERROR.USER_GENERIC_TEXT": "Korisnik nije dodan.",
		"ERROR.FILE_UNAVAILABLE": "Nije moguće preuzeti dokument",
		"ERROR.VALIDATION": 'Pronađene greške validacije',
		"ERROR.TITLE_REQUIRED": 'Naslov je obavezno polje',
		"ERROR.DESCRIPTION_REQUIRED": 'Opis je obavezno polje',
		"ERROR.LOCATION_NOT_FOUND": 'Lokacija nije pronađena',
		"ERROR.WORK_HIERARCHY_NOT_FOUND": 'Radna hijerarhija nije pronađena',
		"ERROR.WRONG_FREQUENCY": "Pogrešna frekvencija ponavljanja",
		"ERROR.FREQUENCY_REQUIRED": 'Frekvencija ponavljanja je obavezno polje',
		"ERROR.FIRST_SERVICE_DATE_FROM_REQUIRED": 'Datum prvog servisa "od" je obavezno polje',
		"ERROR.FIRST_SERVICE_DATE_TO_REQUIRED": 'Datum prvog servisa "do" je obavezno polje',
		"ERROR.END_DATE_REQUIRED": "Zaključni datum je obavezno polje",
		'ERROR.WRONG_PLANNED_START_DATE_FORMAT': 'Pogrešan format datuma prvog servisa "od"',
		'ERROR.WRONG_PLANNED_END_DATE_FORMAT': 'Pogrešan format datuma prvog servisa "do"',
		'ERROR.WRONG_CUT_DATE_FORMAT': 'Pogrešan zaključni datum',
		'ERROR.PLANNED_START_DATE_NEEDS_TO_BE_BEFORE_PLANNED_END_DATE': 'Datum prvog servisa "od" treba biti prije datuma prvog servisa "do"',
		'ERROR.CUT_DATE_NEEDS_TO_BE_AFTER_PLANNED_END_DATE': 'Zaključni datum treba biti poslije datuma prvog servisa "do"',
		'ERROR.WRONG_MOBILE': 'Pogrešan broj mobitela',
		'ERROR.SUPPLIER_NOT_FOUND': 'Dobavljač nije pronađen',
		'ERROR.COST_ESTIMATE_NEEDS_TO_BE_FLOAT': 'Procjena troška servisa treba biti decimalan broj',

		'ERROR.DELETING_COLUMNS': 'Zabranjeno brisanje kolona',
		'ERROR.ADDING_COLUMNS': 'Zabranjeno dodavanje kolona',
		'ERROR.HIDDING_COLUMNS': 'Zabranjeno skrivanje kolona',
		'ERROR.REQUIRED_FIELDS': 'Kolone označene sa * su obavezne za popuniti.',
		'ERROR.PLANNED_DATE': 'Datumi moraj biti u obliku',
		'ERROR.DROP_DOWN_VALUES': 'Određene kolone imaju dropdown vrijednost (Radna hijerarhija 1,2 i 3)',
		'ERROR.WORK_HIERARCHY_ORDER': 'Radne hijerarhije potrebno je odabrati po redosljedu: Radna hijerarhija 1 -> Radna hijerarhija 2 -> Radna hijerarhija 3',


		"MANUAL": "Upute",
		"MANAGE_ACCOUNT": "Račun",
		"NAVROUTE.LOGOUT": "Odjava",
		"LOGOUT": "Odjava",

		"NAVROUTE.MAIN": "Matični podaci",
		"NAVROUTE.COMPANIES": "Kompanije",
		"NAVROUTE.DASHBOARD": "Nadzorna ploča",
		"NAVROUTE.USERS": "Korisnici",
		"NAVROUTE.LOCATIONS": "Lokacije",
		"NAVROUTE.LOCATION_GROUPS": "Grupe lokacija",
		"NAVROUTE.METERS": "Brojila",
		"NAVROUTE.SUPPLIERS": "Dobavljači",
		"NAVROUTE.ORDERS": "Nalozi",
		"NAVROUTE.ORDER": (order_id) => `Nalog #${order_id}`,
		"NAVROUTE.TICKETS": "Prijave",
		"NAVROUTE.TICKET": (ticket_id) => `Prijava #${ticket_id}`,
		"NAVROUTE.WORKGROUPS": "Grupe radova",
		"NAVROUTE.SECTORS": "Sektor",
		"NAVROUTE.WORKHIER": "Radna hijerarhija",
		"NAVROUTE.PRICELIST": "Cjenik",
		"NAVROUTE.REPORTS": "Izvještaji",
		"NAVROUTE.ARRIVALS": "Dolasci",
		"NAVROUTE.ARRIVAL": (arrival_id) => `Dolazak #${arrival_id}`,
		"NAVROUTE.ANALYTICS": "Analitika",
		"NAVROUTE.SETTINGS": "Postavke",
		"NAVROUTE.EDIT_QUESTIONNAIRES": "Uređivanje upitnika",
		"NAVROUTE.CALENDAR": "Kalendar",
		"NAVROUTE.SHELF_FILLER": "Punjenje polica",
		"NAVROUTE.SCHEDULED_ORDERS": "Servisi",
		"NAVROUTE.CHECKLISTS": "Kontrolne liste",
		"NAVROUTE.ADMIN": "Admin panel",
		"NAVROUTE.REQUESTS": "Request log",
		"NAVROUTE.LABEL_FLAGS": 'Oznake',
		"NAVROUTE.COMPANY_SETTINGS": "Postavke tvrtke",
		"NAVROUTE.JOB_MANAGEMENT": "Upravljanje poslovima",
		"NAVROUTE.TEMPS_REQUESTS": "Zahtjevi za radnicima",
		"NAVROUTE.EXTERNAL_WORKERS": "Vanjski radnici",
		"NAVROUTE.WORKING_HOURS": "Pregled radnih sati",
		"NAVROUTE.APPLICATIONS": "Prijave za posao",
		"NAVROUTE.JOBS_CALENDAR": "Kalendar poslova",

		"DELETED": "Obrisano",

		"TICKET": "Prijava",
		"ORDER": "Nalog",
		"ARRIVAL": "Dolazak",
		"SCHEDULED_ORDER": "Servis",

		"STATUS.ACTIVE": "Aktivan",
		"STATUS.CREATED": "Kreiran",
		"STATUS.HAS_ARRIVAL": "Dolazak kreiran",
		"STATUS.INACTIVE": "Neaktivan",
		"STATUS.APPROVED": "Odobren",
		"STATUS.ON_HOLD": "Na čekanju",
		"STATUS.IN_EXECUTION": "U izvršavanju",
		"STATUS.EXECUTED": "Izvršen",
		"STATUS.INVOICED": "Fakturirano",
		"STATUS.DELETED": "Obrisano",
		"STATUS.REJECTED": "Odbijen",
		"STATUS.ON_COMPANY_REVIEW": "Prefakturiranje",
		"STATUS.ON_SUPPLIER_REVIEW": "Prefakturiranje",
		"STATUS.UNDONE": "Neodrađeno",
		"STATUS.WORKS_FINISHED": "Radovi završeni",

		"STATUS.ON_COMPANY_REVIEW.1": "Prefakturiranje",
		"STATUS.ON_SUPPLIER_REVIEW.1": "Prefakturiranje (Dobavljač)",
		"STATUS.PING_PONG_CHANGED": "Izmjena na stavci",

		"ARRIVAL_DATE": "Dolazak najavljen",
		"ARRIVAL_WORKERS": "Radnici",

		"PRIORITY": "Prioritet",
		"PRIORITY.LOW": "Nizak prioritet",
		"PRIORITY.MEDIUM": "Srednji prioritet",
		"PRIORITY.HIGH": "Visoki prioritet",

		"ORDER_PRIORITY.P1_CRITICAL": "Kritično",
		"ORDER_PRIORITY.P1_CRITICAL.DESC": "Sigurnosni rizik, prekid poslovanja ili nedostupnost kritične infrastrukture",
		"ORDER_PRIORITY.P2_HIGH": "Visoko",
		"ORDER_PRIORITY.P2_HIGH.DESC": "Značajan utjecaj na poslovanje, ali objekt može djelomično funkcionirati",
		"ORDER_PRIORITY.P3_MEDIUM": "Srednje",
		"ORDER_PRIORITY.P3_MEDIUM.DESC": "Ograničen utjecaj na poslovanje ili manji broj korisnika",
		"ORDER_PRIORITY.P4_LOW": "Nisko",
		"ORDER_PRIORITY.P4_LOW.DESC": "Manji kvar bez značajnog utjecaja na poslovanje",

		"RELATED.TICKETS": "Povezane prijave",
		"RELATED.ORDERS": "Povezani nalozi",
		"RELATED.ARRIVALS": "Povezani dolasci",

		"FINANCIAL.TITLE": "Financijski detalji",
		"FINANCIAL_2.TITLE": "Financijska razrada",
		"FINANCIAL.INVOICE": "Fakturiranje",
		"FINANCIAL.INVOICE.TITLE": "Unesite broj računa",
		"FINANCIAL.INVOICE.LABEL": "Račun br.",
		"FINANCIAL.PDF_BY_LOCATION": "Potvrđeno na lokaciji",
		"FINANCIAL.PDF_ALL": "Sve stavke",
		"FINANCIAL.CONFIRM_TITLE": (count)=>`Broj neosporenih stavki: ${count}`,
		"FINANCIAL.CONFIRM_TEXT": "Stavke koje niste osporili će biti potvrđene i nećete ih kasnije moći izmijeniti. Da li ste sigurni da želite potvrditi sve stavke?",
		"FINANCIAL.TAX_DISCLAIMER" : "Iznosi su bez PDV-a",
		"FINANCIAL.CHANGED_ITEM": "Osporena stavka",
		"FINANCIAL.ITEM_DETAILS": "Detalji stavke",
		"FINANCIAL.NEW_ITEM": "Nova stavka",

		"CLICK_TO_EXPAND": "Proširi prikaz",
		"CHECKLISTS.ADD_NEW_Q": "Dodaj novo pitanje",


		"PDF.ORDER": "Prilog fakturi",
		"PDF.ARRIVALS": "Radni nalog",
		"PDF.ORDER.NO_PRICES": "Prilog fakturi bez cijena",

		"KAM.ATTR": "Karakteristike",

		"INVENTORY.RECENT_ORDERS": "Nedavni nalozi",
		"INVENTORY.RECENT_ORDERS.TEXT": "Sljedeći nalozi su nedavno vezani uz ovaj inventar:",
		"INVENTORY.PICK": "Odaberi inventar",
		"EVENT.PICK": "Odaberi tip događaja",
		"USER.TAKE_OVER_LOCATIONS": "Zamjena pri odsustvu",
		"USER.RESPONSIBLE": "Odgovorna osoba",

		"SUPPLIER.IMPORT": "Uvezi servise",
		"SUPPLIER.IMPORT_SERVICE": "Uvoz servisa",
		"SUPPLIER.IMPORT_DOWNLOAD_SERVICE": "Pravila za uređivanje servisa",
        "SUPPLIER.DOWNLOAD": "Preuzmi predložak",
        "SUPPLIER.DIALOG_TITLE": (supp) =>`Uvoz servisa za ${supp}`,
        "SUPPLIER.ERRORS.DEFAULT": "Došlo je do greške kod prihvata uvezene tablice.\nGreške se nalaze u tablici na linijama: ",
        "SUPPLIER.ERRORS": "Greška: uvezena tablica nije prihvaćena.",

        "SUPPLIER.SUCCESS": "Tablica je uspješno uvezena",

		"REQUIRED_FILEDS": "Obavezno popuniti",
		"APPROVE" : "Odobri",
		"REJECT": "Odbij",

		'LOCGROUPS.NFC_ON': 'Označi NFC za sve lokacije',
        'LOCGROUPS.NFC_OFF': 'Ukloni NFC sa svih lokacija',
		'LOCGROUPS.NFC_ON_TITLE': 'NFC skeniranje dolaska za sve lokacije u grupi je UKLJUČENO.',
		'LOCGROUPS.NFC_OFF_TITLE': 'NFC skeniranje dolaska za sve lokacije u grupi je ISKLJUČENO.',
		'LOCGROUP.LOCATION_NCF': 'NFC na lokaciji',
		'LOCGROUP.GROUP_NFC': 'NFC na grupi',

		'SHOW_MORE': (num)=> num > 3 ? `Prikaži svih ${num}` : 'Prikaži više',
		'COMPANY': 'Tvrtka',

		"FROM": "Od",
		"TO": "Do",
	}
};

export const nav_translations = [english, croatian];
